import { personalizedSlipSchema } from "@redotech/redo-model/personalized-slip/personalized-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const generatedTextBlockSchema_ = z.object({
  blockId: z.string(),
  generatedText: z.string(),
  characterCount: z.number(),
  fitsConstraints: z.boolean(),
  warning: z.string().nullish(),
});
export const generatedTextBlockSchema: z.ZodType<GeneratedTextBlockSchema> =
  generatedTextBlockSchema_;
export interface GeneratedTextBlockSchema
  extends z.infer<typeof generatedTextBlockSchema_> {}

const recommendedProductSchema_ = z.object({
  productId: z.string(),
  title: z.string(),
  description: z.string(),
  imageUrl: z.string().nullish(),
  price: z.string().nullish(),
  discountCode: z.string().nullish(),
});
export const recommendedProductSchema: z.ZodType<RecommendedProductSchema> =
  recommendedProductSchema_;
export interface RecommendedProductSchema
  extends z.infer<typeof recommendedProductSchema_> {}

export const generatePersonalizedSlipPreview = {
  name: "generatePersonalizedSlipPreview" as const,
  input: z.object({
    templateId: zExt.objectId(),
    template: personalizedSlipSchema,
  }),
  output: z.object({
    orderId: z.string(),
    orderNumber: z.string().nullish(),
    customerName: z.string().nullish(),
    recommendations: z.array(recommendedProductSchema),
    generatedTextBlocks: z.array(generatedTextBlockSchema),
    generatedSlip: personalizedSlipSchema,
    qrCodeDataUrls: z.record(z.string(), z.string()),
  }),
};
